import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
function CheckboxComponent({ node, updateAttributes }) {
  const { id } = node.attrs;
  return (
    <NodeViewWrapper
      id={id}
      data-placeholder-id={id}
      data-field-id={id}
      as="span"
      className="
    inline-flex
    items-center
    gap-2
    align-middle
    checkbox-field
  "
    >
      {/* checkbox */}
      <button
        onClick={() => updateAttributes({ checked: !node.attrs.checked })}
        className={`
  w-5 h-5 rounded-md border flex items-center justify-center

  transition-all duration-200

  ${
    node.attrs.checked
      ? 'bg-[#375AE7] border-[#375AE7] text-white shadow-sm'
      : 'bg-white border-slate-300 hover:border-slate-400'
  }

  hover:scale-105 active:scale-95
`}
      >
        {node.attrs.checked && '✓'}
      </button>

      {/* label */}
      {node.attrs.label && (
        <span className="text-sm text-slate-700 whitespace-nowrap">
          {node.attrs.label}
        </span>
      )}
    </NodeViewWrapper>
  );
}

export const Checkbox = Node.create({
  name: 'checkbox',

  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
      },
      checked: {
        default: false,
      },
      label: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [{ tag: 'checkbox' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'checkbox',
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CheckboxComponent);
  },
});
